<template>
    <div>
	<main role = 'main' >
	<section class="jumbotron text-center">		
	<br>
	<h1>台灣商港動態網</h1>
	<p>
	彙整「<a href = https://test-tpnet.twport.com.tw/IFAWeb/CMS/>臺灣港棧服務網 TPNET</a>」<br>
	相關開放資料，提供符合現代　<br>
	瀏覽習慣的排版內容，備註：　<br>
	本站提供資料僅供參考，正確資料<br>
	請洽：「臺灣港務股份有限公司」<br>
	<br>
	</p>
	<h2>功能說明</h2>
	<p>
	港口代碼：<br>
	輸入港口名稱、代碼<br>
	會查詢出對應的資料<br>
	</p>
	
	<h2> 其他說明 </h2>
	<p>
	「預報」出港 / 進港：<br>
	業者在MTNet預報的時間<br>
	
	<br>
	「預計(定)」靠泊 / 離泊：<br>
	業者在TPNet預計的時間<br>
	<br>
	
	<br>
	如果要較準確的出港前時間<br>
	建議查詢「預計引水時間」<br>
	

	<br>
	本站所導引查詢AIS系統
	<br>
	引用於 <a href = https://www.vesselfinder.com/>Vesselfinder</a>
	<br>
	僅供參考
	<br>
	<br>
	其他查船管道<br>
	
	「<a href = https://m.mtnet.gov.tw/MTNetMobileWeb/>航政監理行動平台 MTNET</a>」<br>
	「<a href = http://www.shinhwa.com.tw/>新華航業-臺馬之星</a>」<br>
	「<a href = http://www.allports.com.tw/>全港通航業-臺馬輪</a>」<br>
	</p>
	<br>
	其他更新說明請洽<a href = /blog>BLOG</a>
	<br>
	<p>
	若有使用AdBlock等阻擋廣告套件<br>
	請先關閉，方可順利查詢<br>
	本站不支援IE10以下的版本<br>
	建議使用Chrome瀏覽<br>
	</p>
	
	
	<div class="container">
		<div id="fb-root"></div>
		<div class="fb-comments" data-href="https://www.facebook.com/shipsTime.tw/" data-numposts="5"></div>
	</div>
	
	
	</section>
	</main>
    </div>    
</template>

<script>(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = 'https://connect.facebook.net/zh_TW/sdk.js#xfbml=1&version=v3.1&appId=1468979350030440&autoLogAppEvents=1';
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));</script>


// WEBPACK FOOTER //
// src/components/Introduction.vue